$(document).ready(function () {

  document.querySelector('#HeaderMenu-certifications-florida-approvals-on-florida-dbpr-website').setAttribute('target','_blank');
  document.querySelector('#HeaderMenu-certifications-miami-dade-county-approval').setAttribute('target','_blank');
  document.querySelector('#HeaderMenu-certifications-miami-dade-county-stickers').setAttribute('target','_blank');
  document.querySelector('#HeaderMenu-certifications-miami-dade-county-qa-acceptance').setAttribute('target','_blank');


// collection product grid same height
      let arrayNum = [];
      let product_list = document.querySelectorAll('.collection .product-grid .diameter_define');

      product_list.forEach(item => {
          let getHeight = item.querySelector('.diameter_define .grid__item').offsetHeight;
          arrayNum.push(getHeight);
      });

      function largestNumber(number) {
          let max = number[0];
          for (let i = 1; i < number.length; i++) {
              if (number[i] > max) {
                  max = number[i];
              }
          }
          return max;
      }
      let result = largestNumber(arrayNum);
      // console.log(result);
      product_list.forEach(item => {
          item.querySelector('.diameter_define .grid__item').style.minHeight = result + 'px';
      });


// vent wizard
        let arrayNum_vent = [];
      let product_list_vent = document.querySelectorAll('.handle_vent-wizard  .collection .product-grid .grid__item');

      product_list_vent.forEach(item_v => {
          let getHeight = item_v.offsetHeight;
          arrayNum_vent.push(getHeight);
      });

      function largestNumber(number) {
          let max = number[0];
          for (let i = 1; i < number.length; i++) {
              if (number[i] > max) {
                  max = number[i];
              }
          }
          return max;
      }
      let result_vent = largestNumber(arrayNum_vent);
      // console.log(result_vent);
      product_list_vent.forEach(item_v => {
          item_v.style.minHeight = result_vent + 'px';
      });
  

  // slider
  
  $(".itg_collection_banner").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
    prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
    nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {

  $('.itg_collection_banner_img').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows:false,
    autoplay:true,
    infinite:false,
    loop:true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  function proslider() {
    $('.slider-for').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       fade: true,
       asNavFor: '.slider-nav',
       infinite:false,
       prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="#000" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
       nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="#000" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>'
    });
    $('.slider-nav').slick({
       slidesToShow: 4,
       slidesToScroll: 1,
       asNavFor: '.slider-for',
       dots: false,
       arrows: true,
       focusOnSelect: true,
       infinite:false,
       prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="#000" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
       nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="#000" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>'
    });
  }
  proslider();
   enableZoomOnHover(2);


   if($(document).find('#itoris_dynamicproductoptions').length > 0){
     if($(document).find('#aluminum_box_ul').length > 0){
       jQuery(document).find('.aluminum_box_main li.choice.admin__field').addClass('active');
       var get_name = $(this).find('.aluminum_box_main li.choice.admin__field p.radio.admin__control-radio').attr('data-name');
       // console.log(get_name);
       if(get_name){
         // $(document).find("#proOtn_value").attr('name','properties[Color Name]');
          // $(document).find('#proOtn_value').val(get_name);
          var otherInput = $(document).find('.first_itoris_dynamicproductoptions').attr('data-var');
          $(document).find('.itgdata_color [data-find="'+otherInput+'"]').click();
       }
     }
  }

  $(document).on("click","#aluminum_box_ul li, #standard_box_ul li",function() {
      $(document).find('.proOpt_link-list_dropdown').removeClass('active');
      var chnList = $(document).find('.dpo_dd_list_outer .proOpt_link-list:first').html();
      $(document).find('.link_list_value').html(`<div class='varient_option_value_head'>${chnList}</div>`);
      $(document).find('.itg_remove_border li').removeClass('active');
      $(this).addClass('active');
      var get_name = $(this).find('p.radio.admin__control-radio').attr('data-name');
    
      if (get_name == "Aluminum Unpainted"){
          $(document).find("#proOtn_value").attr('name','');
          $(document).find('#proOtn_value').val('');
      }else{
          $(document).find("#proOtn_value").attr('name','properties[Color Name]');
          $(document).find('#proOtn_value').val(get_name);
      }
      var otherInput = $(this).closest('.itoris_dynamicproductoptions').attr('data-var');
      $(document).find('.itgdata_color [data-find="'+otherInput+'"]').click();

      var thsalt = $.trim($(this).find('p.product-custom-option').attr('data-name'));
      if(thsalt){
           var check_alt = 0;
           jQuery(document).find('.thumbnail-slider li img').each(function() {
        	   var ths_altcpm = jQuery.trim(jQuery(this).attr('alt'));
        	   if(thsalt == ths_altcpm){
        	      check_alt = 1;
        	   }
            });
            if(check_alt == 1){
              image_data(thsalt);
            }else{
              image_all();
            }
      }
  });
    
  $(document).on("click", ".proOpt_link-list_dropdown", function() {
    var $mainList = $(this).siblings('.dpo_dd_list_outer').fadeToggle();
    $('.proOpt_link-list_dropdown span.dropdown_arrow').toggleClass('dropdown_active');
  });
      
  $(document).on("click",".proOpt_link-list",function() {
    var variant_Data = $(this).html();
     var listVariant = $(this).text().split('+')[0].trim();
     $(document).find('.proOpt_link-list_dropdown').addClass('active');
     $(this).parents('.main_option').find('.link_list_value').html(`<div class='varient_option_value_head'>${variant_Data}</div>`);
     // $('.dropdown_arrow').hide();
     //$('.proOtn_value').val(listVariant);
      $(document).find("#proOtn_value").attr('name','properties[Color Name]');
      $(document).find('#proOtn_value').val(listVariant);
     //$(document).find('#proOtn_value').val(listVariant);
     $(this).parents('.main_option').find('.dpo_dd_list_outer').fadeToggle();
     $(document).find('#standard_box_ul li').removeClass('active');
     $(document).find('#aluminum_box_ul li').removeClass('active');
     $('.proOpt_link-list_dropdown span.dropdown_arrow').removeClass('dropdown_active');
     var otherInput = $(this).closest('.itoris_dynamicproductoptions').attr('data-var');
     $(document).find('.itgdata_color [data-find="'+otherInput+'"]').click();

      var thsalt = $(this).text().split('+')[0].trim();
      if(thsalt){
         var check_alt = 0;
         jQuery(document).find('.thumbnail-slider li img').each(function() {
             var ths_altcpm = jQuery.trim(jQuery(this).attr('alt'));
             if(thsalt == ths_altcpm){
                check_alt = 1;
             }
          });
          if(check_alt == 1){
            image_data(thsalt);
          }else{
            image_all();
          }
      }
  });

  function image_all() {
     jQuery(document).find('.slider-for').slick('unslick');
     jQuery(document).find('.slider-nav').slick('unslick');
     jQuery(document).find('.slider-nav').html('');
     jQuery(document).find('.slider-for').html('');
   
     jQuery(document).find('.mian_slide_data .altdata').each(function() {
         var ths_altcpm = $(this).data('alt');
         var thisdata = $(this).html();
         jQuery(document).find('.slider-nav').append(thisdata);
     });
   
     jQuery(document).find('ul.product-main-data .main-alt-data').each(function() {
         var ths_altcpm = $(this).data('alt');
         var mainData = $(this).html();
         jQuery(document).find('.slider-for').append(mainData);
     });
    proslider();
     enableZoomOnHover(2);
  }
  function image_data(getimg) {
      var thsalt = getimg;
       jQuery(document).find('.slider-for').slick('unslick');
       jQuery(document).find('.slider-nav').slick('unslick');
       jQuery(document).find('.slider-nav').html('');
       jQuery(document).find('.slider-for').html('');
   
       jQuery(document).find('.mian_slide_data .altdata').each(function() {
           var ths_altcpm = $(this).data('alt');
           if(ths_altcpm == thsalt){
             var thisdata = $(this).html();
             jQuery(document).find('.slider-nav').append(thisdata);
           }
       });

       var second_img = jQuery(document).find('.mian_slide_data .altdata[data-alt="product_3d"]').html();
       if(second_img){
           jQuery(document).find('.slider-nav li').each(function(i) {
             var i = i+1;
             $(this).attr('data-index',i);
           });
           $('.slider-nav li[data-index="1"]').after(second_img);
        }
         
       jQuery(document).find('ul.product-main-data .main-alt-data').each(function() {
         var ths_altcpm = $(this).data('alt');
         if(ths_altcpm == thsalt){
           var mainData = $(this).html();
           jQuery(document).find('.slider-for').append(mainData);
           //console.log(mainData);
         }
       });
      var second_img = jQuery(document).find('ul.product-main-data .main-alt-data[data-alt="product_3d"]').html();
      if(second_img){
         jQuery(document).find('.slider-for li').each(function(i) {
           var i = i+1;
           $(this).attr('data-index',i);
         });
         $('.slider-for li[data-index="1"]').after(second_img);
      }
     
      proslider();
      enableZoomOnHover(2);
  }

  if($(document).find('.itgdata_option').length > 0){
     var first_id = $(document).find('.product-variant-id').val();
      $(document).find('select#Variants-metafiled_data option').each(function(){
         var thsid = $(this).attr('value');
         if(thsid == first_id){
           var thsDes = $(this).attr('data-des');
           if(thsDes){
              $(document).find('.rc-ins-option-choice[data-id="'+thsid+'"]').addClass('active');
           }
         }
      });
      $(document).on("click", "fieldset.js.product-form__input.itgdata_option label", function() {
          setTimeout(function() {
               $(document).find('.rc-ins-option-choice').removeClass('active');
               var first_id = $(document).find('.product-variant-id').val();
               $(document).find('select#Variants-metafiled_data option').each(function(){
                 var thsid = $(this).attr('value');
                 if(thsid == first_id){
                   var thsDes = $(this).attr('data-des');
                   if(thsDes){
                      $(document).find('.rc-ins-option-choice[data-id="'+thsid+'"]').addClass('active');
                   }
                 }
              });
          }, 500);
      });
  }
    
  jQuery("#inputString").keyup(function () {
    var filter = jQuery(this).val();
    jQuery(".proOpt_link-list_main li").each(function () {
      if (jQuery(this).text().search(new RegExp(filter, "i")) < 0) {
        jQuery(this).hide();
      } else {
        jQuery(this).show()
      }
    });
  });




  $(document).on("click",".itg_mobile_width_side_menu h3",function() {
     $('.itg_sidebar_div').toggleClass('open');
  });

  if($("body").hasClass("itg_collection")){
     $(document).on("click",".tab-menu li a",function(){
        if($(this).hasClass('active')){
          var target = $(this).attr('data-rel');
          $(this).removeClass('active');
          $("#"+target).hide();
        }else{
          var target = $(this).attr('data-rel');
          $('.tab-menu li a').removeClass('active');
          $(this).addClass('active');
          $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
          return false;
        }
     });

     $(document).on("click",".tab-menu li a.backBtn ",function() {
       $(".tab-box").hide();
     });
     
   }else{
     $('.tab-menu li:first-child a').trigger('click');
     $('.tab-menu li a').on('click', function(){
        var target = $(this).attr('data-rel');
        $('.tab-menu li a').removeClass('active');
        $(this).addClass('active');
        $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
        return false;
     });
   }
   
   $(document).on("click",".itg_sidebar_div.open",function() {
     $(this).removeClass('open');
   });

  // product page color option 
  // $('.itg_color_options_div .label.itg_standard_color_option').click(function(){
  //   alert('ggg');
  //   $('.itg_show_standard_color').slideToggle('slow'); 
  // });
  
  $('.itg_selected_color').change(function(){
    //console.log($(this).parents('.itg_color_options_div').find('.color_input:checked').length);
    if($(this).parents('.itg_color_options_div').find('.color_input:checked').length == 1){
    }else{
      $(this).parents('.itg_color_options_div').find('.itg_color_label').trigger('click');
    }
  });
  // itg js
  $(document).on('change','.color_input',function (){
    $('.product-form__input input[type=radio]:checked+label+.itg_show_option label.itg_colors[data-index="1"]').trigger('click');
  });

  $(document).on("click",".itg_show_option ul li input",function() {
     $(document).find('.itg_show_option ul li').removeClass('active');
     $(this).closest('li').addClass("active");
  });

  $(document).on("click",".itg_close",function() {
      $('.itg_cart_popup_wrapper').hide();
  });


  // itg js end 
  $("#itg_form").submit(function(e) {
    $('.loader_main').show();
      e.preventDefault();
    
      // $(document).find("table.cart-items .cart-item").each(function(){
      //     var data_id = $(this).attr('data-id');
      //     var data_qty = $(this).find('.quantity__input').val();
      //     bundle_product +=data_id+':'+data_qty+',';
      //  });
      // var bundle_product = '';
      //  var lastCommaRemoved = bundle_product.replace(/,*$/, ''); 
    
      fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
              // console.log('Cart JSON:', data.items);
              var ajaxData = new FormData;
           
              var Cart_data = data.items;
              var jsonCartData = JSON.stringify(Cart_data);
              var itg_email = $('#itg_email').val();
              var itg_country = $('#itg_country option:selected').val();
              var itg_fname = $('#itg_fname').val();
              var itg_lname = $('#itg_lname').val();
              var itg_address = $('#itg_address').val();
              var itg_city = $('#itg_city').val();
              var itg_state = $('#itg_state').val();
              var itg_zibcode = $('#itg_zibcode').val();
              var itg_phone = $('#itg_phone').val();
              var itg_company = $('#itg_company').val();
              var itg_note = $('#Cart-note').val();
           //  console.log(itg_note);

              ajaxData.append('bundledata', jsonCartData);
              ajaxData.append('itg_email', itg_email);
              ajaxData.append('itg_country', itg_country);
              ajaxData.append('itg_fname', itg_fname);
              ajaxData.append('itg_lname', itg_lname);
              ajaxData.append('itg_address', itg_address);
              ajaxData.append('itg_city', itg_city);
              ajaxData.append('itg_state', itg_state);
              ajaxData.append('itg_zibcode', itg_zibcode);
              ajaxData.append('itg_phone', itg_phone);
              ajaxData.append('itg_company', itg_company);
              ajaxData.append('itg_note', itg_note);

          //  console.log(ajaxData);
            
              $(document).find('#draft_product_order').text('wait..');
              $.ajax({
                  url: 'https://dev.shopifyexperthelp.com/app/project_app/roofvents/draft_order.php',
                  type: 'POST',
                  data: ajaxData,
                  dataType: false,
                  cache: false,
                  contentType: false,
                  processData: false,
                  complete: function() {

                  },
                  success: function(res) {
                       //console.log(res);
                      $(document).find('#draft_product_order').text('Order Create');
                      $('#itg_form')[0].reset();
                      fetch('/cart/clear.js', {
                              method: 'POST',
                              headers: {
                                  'Content-Type': 'application/json',
                              },
                          })
                          .then(response => {
                              if (response.ok) {
                                  window.location.href = "/pages/thank-you";
                                  // $('.loader_main').hide();
                                  console.log('Cart cleared successfully!');
                              }
                          });
                  },
                  error: function(xhr, textStatus, errorThrown) {
                      //console.log(xhr.statusText);
                      //console.log(textStatus);
                      //console.log(errorThrown);
                  }
              });
          })
          .catch(error => {
              console.error('Error fetching cart JSON:', error);
          });
  });



  
  $(document).on('click', '.itg_view_3dproduct', function(){
    $('.itg_3dimage_wrapper').css("opacity","1").css("visibility", "visible");
  });
  $(document).on('click', '.itg_close', function(){
    $('.itg_3dimage_wrapper').css("opacity","0").css("visibility", "hidden");
  });

  //menu click
   $(document).on("click", ".itg_header_wrapper header.header nav.header__inline-menu ul.list-menu details ul.header__submenu li details", function(){
     $(this).parent('li').siblings('li').find('details').removeAttr('open');
   });


  // home page tab
  var menuUrl = window.location.href;
  var splitUrl = menuUrl.split("/#");
  var splittedOne = splitUrl[1];
  // console.log(splittedOne);
  if (splittedOne) {
    $(".itg_sidebar_sections_inner .itg_subcollections_list").hide();
    $("#" + splittedOne).show();
    $('.sidebar-link-item[data-ids='+ splittedOne +']').addClass('active');
    $("html, body").animate({
      scrollTop: 0
    }, 1000);
  } 
  // else {
  //   var menuTitle = $(".sidebar-links .sidebar-link-item:first-child").data("ids");
  //   $(".sidebar-sub-link .itg_subcollections_list").each(function () {
  //     var sideBarTitle = $(this).data("title");
  //     if (menuTitle == sideBarTitle) {
  //       $(".itg_sidebar_sections_inner .itg_subcollections_list").hide();
  //       $(this).show();
  //       $(".sidebar-links li:first-child .sidebar-link-item").addClass('active');
  //     }
  //   });
  // }


  //   $(".sidebar-links .sidebar-link-item").on("click", function (event) {
  //   var menuTitle = $(this).data("ids");
  //   $(this).closest(".sidebar-links").find(".sidebar-link-item").removeClass("active");
  //   $(this).addClass("active");
  //   $(".sidebar-sub-link .itg_subcollections_list").each(function () {
  //     var sideBarTitle = $(this).data("title");
  //     if (menuTitle == sideBarTitle) {
  //       $(".itg_sidebar_sections_inner .itg_subcollections_list").hide();
  //       $(this).show();
  //       $(this).find('.acc__title').addClass('active_val');
  //       $(this).find('.lists').show();
  //       $("html, body").animate({
  //       scrollTop: 0
  //       }, 500);
  //     } 
  //   });
  // });
  
  $(".sidebar-links .sidebar-link-item").on("click", function (event) {
    event.preventDefault();

    var menuTitle = $(this).data("ids");
    $(this).closest(".sidebar-links").find(".sidebar-link-item").removeClass("active");
    $(this).addClass("active");

    // Delay execution of the following logic by 200 milliseconds
    setTimeout(function () {
      $(".sidebar-sub-link .itg_subcollections_list").each(function () {
        var sideBarTitle = $(this).data("title");

        if (menuTitle === "11-square-roof-curbs") {
          $(".itg_sidebar_sections_inner .itg_subcollections_list").hide();
          $(".itg_sidebar_sections_inner .itg_subcollections_list[data-title='11-square-roof-curbs']").show();
          $(".itg_sidebar_sections_inner .itg_subcollections_list[data-title='square-roof-curbs-insulated']").show();
          $(this).find('.acc__title').addClass('active_val');
          $(this).find('.lists').show();
          $("html, body").stop(true, false).animate({ scrollTop: 0 }, 500);
        } else if (menuTitle === sideBarTitle) {
          $(".itg_sidebar_sections_inner .itg_subcollections_list").hide();
          $(this).show();
          $(this).find('.acc__title').addClass('active_val');
          $(this).find('.lists').show();
          $("html, body").animate({ scrollTop: 0 }, 500);
        }
      });
    }, 200); // Delay in milliseconds
  });


  
 // $(document).on("click", function(event){
 //    $('.itg_header_wrapper header.header nav.header__inline-menu ul.list-menu details ul.header__submenu li details').removeAttr('open');
 // });


  //custom sort 
  // $(document).on('click', ".itg_custom_sort li", function(){
  //   var data_val = $(this).attr('data-value');
  //   //alert(data_val);
  //   $('#SortBy-mobile option').each(function(){
  //     var select_val = $(this).val();
  //     var baseUrl = window.location.href.split('?')[0];
  //     var newParams = select_val; // Example parameters
      
  //     //alert(select_val);
  //     if(data_val == select_val){
  //       $('#SortBy-mobile option').attr('selected', false);
  //       $('#SortBy-mobile option[value="'+select_val+'"]').attr('selected', true).trigger('click');
  //       var newUrl = baseUrl + '?sort_by=' + newParams;
  //       alert(newUrl);
  //       $.ajax({
  //       url: window.location.href, // Current URL
  //       type: 'GET',
  //       data: newUrl,
  //       success: function(data) {
  //         // Handle success (optional)
  //         console.log("URL data changed successfully!");
          
  //       },
  //       error: function(xhr, status, error) {
  //         // Handle errors (optional)
  //         console.error("Error occurred:", error);
  //       }
  //     });
  //     }
  //   });
  // });



    
});

  //tab js

  function openTab(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  if($('#defaultOpen').length > 0){
    document.getElementById("defaultOpen").click();
  }


  // Drawing tab js
  var collectioHandle = $('.menu_header_coll').attr('data-coll');
  $('.menu_header_coll:first').siblings().removeClass('active')
  $('.menu_header_coll:first').addClass('active');
  $(document).find(".overlay").addClass('loading');
  $.ajax({
    url: collectioHandle,
    method: "GET",
    dataType: "html",
    }).done(function (responseText) {
      $(document).find(".coll_prdct_metaItem").html('');
       const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
       var divcollectiondata = $(responseHTML).find(".tabcontent").prop("innerHTML");
        $(document).find(".coll_prdct_metaItem").html(divcollectiondata);
        $(document).find(".overlay").removeClass('loading');
    }).fail(function (jqXHR, textStatus, errorThrown) {
      // alert('error');
  });

  $(document).on("click",".menu_header_coll",function() {
     $(this).closest('li').siblings().find('.menu_header_coll').removeClass('active');
     $(this).addClass('active');
     var collectioHandle = $(this).attr('data-coll');
     $(document).find(".overlay").addClass('loading');
      $.ajax({
      url: collectioHandle,
      method: "GET",
      dataType: "html",
    }).done(function (responseText) {
      $(document).find(".coll_prdct_metaItem").html('');
       const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
       var divcollectiondata = $(responseHTML).find(".tabcontent").prop("innerHTML");
        $(document).find(".coll_prdct_metaItem").html(divcollectiondata);
        $(document).find(".overlay").removeClass('loading');
      }).fail(function (jqXHR, textStatus, errorThrown) {
        // alert('error');
    });
  });

$(document).on('click','#draft_product_order_form',function(e){
  e.preventDefault()
  $(document).find('#draft_product_order').trigger('click');  
});

// collection wise filter hide
document.addEventListener("DOMContentLoaded", (event) => {
    var tabClick = document.querySelectorAll('.itg_subcollections_list ul li a');

    tabClick.forEach(function(item) {
        item.addEventListener("click", (e) => {
            localStorage.removeItem("coll-item");
            const getValue = item.closest('.itg_subcollections_list').dataset.title;
            localStorage.setItem("coll-item", getValue);
            let getdata = localStorage.getItem("coll-item");
            // console.log(getdata);
            // e.preventDefault(); 
        });
    });

    let getdata = localStorage.getItem("coll-item");
    console.log(getdata);
    if (getdata) {
        if (getdata == "9-parapet-universal-vents") {
            document.querySelector('body').classList.add('single_hide');
        } else {
            document.querySelector('body').classList.remove('single_hide');
        }
        if (getdata == "1-exhaust-vents" || getdata == "2-intake-vents") {
            document.querySelector('body').classList.add('vent_hide');
        } else {
            document.querySelector('body').classList.remove('vent_hide');
        }

    }

  
 $('a[href="https://iq.ulprospector.com/"]').attr('target', '_blank');
  $('#HeaderMenu-certifications-texas-approvals-on-texas-tdi-website').attr('target', '_blank');
  $('a[href="https://patents.google.com/patent/US20140248834"]').attr('target', '_blank');
  
});


  // $(document).on('click','.itg_subcollections_list',function() {
  //    $(this).toggleClass('active_val');
  //    $('.sidebar-sub-link .lists').removeClass('active');
  //     var value = $(this).data('value');
  //   $('.sidebar-sub-link .lists').each(function() {
  //     var getValue = $(this).data('id');
  //     if (getValue == value){
  //       $(this).toggleClass('active');
        
  //     }else{
         
  //     }
  //    });
  // });

if ($(window).width()< 767){
$('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active_val')) {
      $(this).removeClass('active_val');
    } else {
      $(this).closest('.acc').find('.acc__title.active_val').removeClass('active_val');
      $(this).addClass('active_val');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
}


let inputFields = document.querySelectorAll('.search__input.field__input');
inputFields.forEach(function(inputField) {
  inputField.addEventListener('change', function() {
    let oldstr = inputField.value;
    let words = oldstr.split(' ');
    if (words.length > 0) {
      words[0] = `'${words[0]}'`;
      if (words.length > 1) {
        words[words.length - 1] = `'${words[words.length - 1]}'`;
      }
    }
    inputField.value = words.join(' ');
  });
});


////////////////////Custom Chart View Js//////////////////////////////// 

// document.addEventListener("DOMContentLoaded", function () {
//     const overlay = document.getElementById("popup-overlay");
//     const model = document.getElementById("popup-modal");
//     const closeButton = document.getElementById("close-popup");
//     const openButton = document.getElementById("open-popup"); // Clickable Element

//     if (overlay && model && openButton) {
//         function showPopup() {
//             overlay.style.display = "block";
//             model.style.display = "block";
//         }

//         function hidePopup() {
//             overlay.style.display = "none";
//             model.style.display = "none";
//         }

//         openButton.addEventListener("click", showPopup); // Click to open
//         closeButton.addEventListener("click", hidePopup); // Close button
//         overlay.addEventListener("click", hidePopup); // Click outside to close
//     }
// });



$(document).ready(function(){
  $('#aluminum_box_ul li').trigger('click');
});



// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}





 // const form = document.getElementById("itg_form");
 //  const fields = form.querySelectorAll("[required]");
 //  let timeoutId = null;

 //  const requiredFieldMap = new Map();
 //  fields.forEach(field => {
 //    requiredFieldMap.set(field, true);
 //  });

 //  window.addEventListener("scroll", () => {
 //    requiredFieldMap.forEach((_, field) => {
 //      field.removeAttribute("required");
 //    });

 //    clearTimeout(timeoutId);

 //    timeoutId = setTimeout(() => {
 //      requiredFieldMap.forEach((_, field) => {
 //        field.setAttribute("required", "");
 //      });
 //    }, 300);
 //  });





// document.addEventListener("DOMContentLoaded", function () {
//   const filterLabels = document.querySelectorAll('.outside-length .facets__summary .facets__summary-label');

//   filterLabels.forEach(function(label) {
//     if (label.textContent.trim() === 'Outside L x W') {
//       label.textContent = 'Outside Length (inches)';
//     }
//   });
// });


//  document.addEventListener("DOMContentLoaded", function () {
//    const para = document.querySelector(".outside-length .facets__summary .facets__summary-label");
//    para.textContent = "Outside L x W";
//  });
// function fixOutsideLabel() {
//   const labels = document.querySelectorAll('.outside-length .facets__summary-label');
//   labels.forEach(function(label) {
//     const text = label.textContent.trim();

//     const match = text.match(/\((\d+)\)$/); 

//     const count = match ? ` ${match[0]}` : "";
//     const newText = "Outside L x W" + count;

//     if (text !== newText) {
//       label.textContent = newText;
//     }
//   });
// }

// document.addEventListener("DOMContentLoaded", function () {
//   fixOutsideLabel();

//   document.addEventListener("click", function (e) {
//     if (e.target.matches(".outside-length .facet-checkbox")) {
//       fixOutsideLabel();
//     }
//   });

//   const target = document.querySelector(".outside-length");
//   if (target) {
//     const observer = new MutationObserver(function () {
//       fixOutsideLabel();
//     });

//     observer.observe(target, {
//       childList: true,
//       subtree: true
//     });
//   }
// });


  // const sidebutton = document.querySelector('.sidebar-links li[data-ids="square-roof-curbs"]');
  // const sideblock = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-insulated');
  // sidebutton.addEventListener("click", function(){
  // let addheading = sidebutton.document.querySelector('.acc__title active_val');
  //   addheading.textContent = "Square Roof Curbs(Non)";
  //   sideblock.classList.add('show_block');
  // });


// const sidebutton = document.querySelector('.sidebar-links li[data-ids="square-roof-curbs"]');
// const sideblock = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-insulated');

// sidebutton.addEventListener("click", function () {
//   const addheading = sidebutton.querySelector('.acc__title');
  
//   if (addheading) {
//     addheading.textContent = "Square Roof Curbs (Non insulated)";
//   }

//   if (sideblock) {
//     sideblock.classList.add('show_block');
//   }
// });
// document.body.addEventListener("click", function () {
//   if (sideblock) {
//     sideblock.classList.remove('show_block');
//   }
// });

// const sidebutton = document.querySelector('.sidebar-links li[data-ids="square-roof-curbs"]');
// const removebutton = document.querySelector('.sidebar-links li');
// const sideblock = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-insulated');

// sidebutton.addEventListener("click", function (event) {
//   if (sidebutton.contains(event.target)) {
//   const addheading = sidebutton.querySelector('.acc__title');
//   if (addheading) {
//     addheading.textContent = "Square Roof Curbs (Non insulated)";
//   }
//     sideblock.classList.add('show_block');
//   } 
// });

// removebutton.addEventListener("click", function () {
//    sideblock.classList.remove('show_block');
// }


// const sidebutton = document.querySelector('.sidebar-links li[data-ids="square-roof-curbs"]');
// const sideblock = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-insulated');
// const noninsulated = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-non-insulated');
// const rubcurb = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs');

// sidebutton.addEventListener("click", function (event) {
//   event.stopPropagation(); 
//   sideblock.classList.add('show_block');
//   noninsulated.classList.add('show_block');
//   // rubcurb..classList.add('hide');
// });

// const allButtons = document.querySelectorAll('.sidebar-links li');

// allButtons.forEach(button => {
//   if (button !== sidebutton) {
//     button.addEventListener("click", function () {
//       sideblock.classList.remove('show_block');
//        noninsulated.classList.remove('show_block');
//         rubcurb..classList.add('show');
//     });
//   }
// });


const sidebutton = document.querySelector('.sidebar-links li[data-ids="square-roof-curbs"]');
const sideblock = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-insulated');
const noninsulated = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs-non-insulated');
const rubcurb = document.querySelector('.itg_sidebar_sections_inner li#square-roof-curbs');

sidebutton.addEventListener("click", function (event) {
  event.stopPropagation();
  sideblock.classList.add('show_block');
  noninsulated.classList.add('show_block');
  rubcurb.classList.add('hide'); 
});

const allButtons = document.querySelectorAll('.sidebar-links li');

allButtons.forEach(button => {
  if (button !== sidebutton) {
    button.addEventListener("click", function () {
      sideblock.classList.remove('show_block');
      noninsulated.classList.remove('show_block');
      rubcurb.classList.remove('show'); // restore when other button clicked
    });
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   const nonInsulated = document.querySelector('#square-roof-curbs-non-insulated');
//   const insulated = document.querySelector('#square-roof-curbs-insulated');
//   const mainCurb = document.querySelector('#square-roof-curbs');

//  const Textadd = document.querySelector("#square-roof-curbs-non-insulated .sidebar-des");
//   Textadd.textContent = "11.";
  
//   if (!nonInsulated || !insulated || !mainCurb) {
//     console.warn('One or more elements not found!');
//     return;
//   }
//   mainCurb.innerHTML = ''; 

//   mainCurb.innerHTML += nonInsulated.innerHTML;

//   mainCurb.innerHTML += insulated.innerHTML;
// });

function moveCurbContent() {
  const nonInsulated = document.querySelector('#square-roof-curbs-non-insulated');
  const insulated = document.querySelector('#square-roof-curbs-insulated');
  const mainCurb = document.querySelector('#square-roof-curbs');
  const Textadd = document.querySelector("#square-roof-curbs-non-insulated .sidebar-des");

  if (nonInsulated && insulated && mainCurb && Textadd) {
    Textadd.textContent = "11.";
    mainCurb.innerHTML = '';
    mainCurb.innerHTML += nonInsulated.innerHTML;
    mainCurb.innerHTML += insulated.innerHTML;
  } else {
    requestAnimationFrame(moveCurbContent); // Try again on next frame
  }
}

document.addEventListener("DOMContentLoaded", moveCurbContent);

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const squaremainCurb = document.querySelector('#square-roof-curbs');
    const sixopen = document.querySelector('.itg_subcollections_list ul.lists.acc__panel[data-id="tabs-16"]');
    const sevanopen = document.querySelector('.itg_subcollections_list ul.lists.acc__panel[data-id="tabs-17"]');

    if (squaremainCurb && sixopen && sevanopen) {
      squaremainCurb.addEventListener("click", function () {
        if (sixopen.style.display === "block") {
          sixopen.style.display = "none";
          squaremainCurb.classList.remove("active");
        } else {
          sixopen.style.display = "block";
           squaremainCurb.classList.add("active");
        }
        if (sevanopen.style.display === "block") {
          sevanopen.style.display = "none";
        } else {
          sevanopen.style.display = "block";
        }
      });
    }
    function toggleDisplay(el) {
      el.style.display = (el.style.display === "block") ? "none" : "block";
    }

  }
});


